export enum LUMX_DIALOGS {
    /**
     * @value Add alternative text
     * @description This is the title of a dialog box that gives the possibility to add alternative text to images.
     */
    INSERT_ALT_TEXT_DIALOG_ADD_TITLE = 'LUMX.INSERT_ALT_TEXT_DIALOG_ADD_TITLE',
    /**
     * @value Edit alternative text
     * @description Title of the alternative text dialog when an alt is already present
     */
    INSERT_ALT_TEXT_DIALOG_EDIT_TITLE = 'LUMX.INSERT_ALT_TEXT_DIALOG_EDIT_TITLE',
    /**
     * @value Alt text is useful for people using screen readers, and will be displayed if the image fails to load.
     * @description Describe to the user the goal of the alt text feature.
     */
    INSERT_ALT_TEXT_DIALOG_HELP_MESSAGE = 'LUMX.INSERT_ALT_TEXT_DIALOG_HELP_MESSAGE',
    /**
     * @value Describe this image...
     * @description Placeholder of the textfield inside the dialog box for alt text on images
     */
    INSERT_ALT_TEXT_DIALOG_INPUT_PLACEHOLDER = 'LUMX.INSERT_ALT_TEXT_DIALOG_INPUT_PLACEHOLDER',
    /**
     * @value Alternative text
     * @description Describe the role of the textfield inside the alt text dialog box.
     */
    INSERT_ALT_TEXT_DIALOG_TEXTFIELD_LABEL = 'LUMX.INSERT_ALT_TEXT_DIALOG_TEXTFIELD_LABEL',
    /**
     * @value Add link
     * @description This is the title of a dialog box that gives the possibility to add link to images.
     */
    LINK_DIALOG_ADD_TITLE = 'LUMX.LINK_DIALOG_ADD_TITLE',
    /**
     * @value Edit link
     * @description Title of the link dialog when a link is already present
     */
    LINK_DIALOG_EDIT_TITLE = 'LUMX.LINK_DIALOG_EDIT_TITLE',
    /**
     * @value Where to navigate when clicking the image...
     * @description Placeholder of the textfield inside the dialog box for link on images
     */
    LINK_DIALOG_INPUT_PLACEHOLDER = 'LUMX.LINK_DIALOG_INPUT_PLACEHOLDER',
    /**
     * @value Main navigation
     */
    MAIN_NAV = 'ADMIN.NAV.MAIN_NAV',
}
